<script setup>
  import { computed } from 'vue';
  import WindGaugeMarkerStation from '@/components/WindGaugeMarkerStation.vue'
  import WindGaugeMarkerNowcast from '@/components/WindGaugeMarkerNowcast.vue'
  import WindGaugeMarkerNoDirection from '@/components/WindGaugeMarkerNoDirection.vue'
  import WindGaugeMarkerDownStation from '@/components/WindGaugeMarkerDownStation.vue'
  import WindGaugeMarkerUpgrade from '@/components/WindGaugeMarkerUpgrade.vue'

  const props = defineProps({
    iconColor: {
      type: String,
      default: 'hsl(360, 100%, 100%)'
    },
    iconType: {
      type: String,
      default: 'hsl(360, 100%, 100%)'
    },
    windDir: {
      type: [Number, null],
      required: true
    },
    status: {
      type: Number,
      required: true
    },
    isNowcast: {
      type: Boolean,
      required: true
    },
    upgrade: {
      type: Array,
      required: true
    }
  });

  const fillColors = {
    'green': '#2eb012',
    'white': '#ffffff',
    'yellow': '#fbdf10',
    'blue': '#91a9d3',
    'purple': '#a15aad',
    'gray': '#c0c0c0',
  }

  const gaugeRotation = computed(() => props.status === 4 ? null : props.windDir)

  const fillColor = computed(() => {
    return props.status === 7
      ? fillColors['gray']
      : props.isNowcast 
      ? fillColors['blue'] 
      : fillColors[props.iconColor]
  });
  
  const upgradeClass = computed(() => props.upgrade[0] ? 'jwx-wind-gauge--upgrade' : '');
</script>

<template>
  <div
    class="jwx-wind-gauge"
    :class="[upgradeClass]"
    :style="`--gauge-rotation: ${gaugeRotation}; --jwx-wind-gauge-fill-color: ${fillColor === '#ffffff' ? '#bbbbbb': fillColor};`"
  >
    <WindGaugeMarkerUpgrade
      v-if="props.upgrade[0]"
    />
    <WindGaugeMarkerDownStation
      v-else-if="props.status === 4"
      :fillColor="fillColor"
    />
    <WindGaugeMarkerNowcast
      v-else-if="props.isNowcast"
      :fillColor="fillColor"
    />
    <WindGaugeMarkerNoDirection
      v-else-if="props.windDir === null"
      :fillColor="fillColor"
    />
    <WindGaugeMarkerStation
      v-else
      :fillColor="fillColor"
    />
  </div>
</template>